module.exports = __webpack_public_path__ + "static/img/header.f3d4715.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/header.jpg
// module id = VC8R
// module chunks = 1